import {ChangeBorrowCourseFormContainer} from "../../../containers/borrowSystem/ChangeAndExtendBorrowForm/ChangeBorrowCourseFormContainer"
export function ChangeBorrowCourseFormPage () {
    return(
        <ChangeBorrowCourseFormContainer/>
    )
}